const COLUMNS = [
  {
    label: 'User ID',
    value: 'user__email',
    disabled: true,
  },
  {
    label: 'Agency',
    value: 'user__agency_default__name',
    disabled: true,
  },
  {
    label: 'User Name',
    value: 'full_name',
  },
  {
    label: 'Object Type',
    value: 'object_type',
  },
  {
    label: 'Record ID',
    value: 'record_id',
  },
  {
    label: 'Field Name',
    value: 'field_name',
  },
  {
    label: 'Action type',
    value: 'action_flag',
  },
  {
    label: 'Previous Value',
    value: 'previous_value_display',
  },
  {
    label: 'New Field Value',
    value: 'new_value_display',
  },
  {
    label: 'Audit Log Date',
    value: 'action_datetime',
  },
  {
    label: 'Submitted',
    value: 'submitted',
  },
  {
    label: 'Entry Type',
    value: 'import_action',
  },
];

const INITIAL_COLUMNS = [
  'user__email',
  'user__agency_default__name',
  'full_name',
  'object_type',
  'record_id',
  'field_name',
  'action_flag',
  'previous_value_display',
  'new_value_display',
  'action_datetime',
  'submitted',
  'import_action',
];

export { COLUMNS, INITIAL_COLUMNS };
